import { FC, useState } from 'react';
import { Redirect } from 'react-router-dom';
import { HStack, Skeleton } from '@chakra-ui/react';

import Heading from 'components/_core/Heading';
import {
  ActionItem,
  usePostOnboardingAccountSetupContext,
} from 'features/PostOnboardingAccountSetup/context';
import * as Layout from 'layouts/ContentLayout';

import * as bankRoutes from '../../../Bank/routes';
import AccountSetupActionCard from '../../components/AccountSetupActionCard';
import AccountSetupCircularProgress from '../../components/AccountSetupCircularProgress';
import OnboardingStepRemovalModal from '../OnboardingStepRemovalModal';
import locales from './locales';

const Setup: FC = () => {
  const {
    actionItems,
    hasCompletedPostOnboardingSetup,
    loading,
    progressLabel,
    progressValue,
  } = usePostOnboardingAccountSetupContext();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedActionItem, setSelectedActionItem] = useState<ActionItem>(
    actionItems[0] as ActionItem,
  );

  const onDismiss = (actionItem: ActionItem) => {
    setIsModalOpen(true);
    setSelectedActionItem(actionItem);
  };

  const onModalClose = () => {
    setIsModalOpen(false);
  };

  if (hasCompletedPostOnboardingSetup) {
    return <Redirect to={bankRoutes.root} />;
  }

  return (
    <Layout.Root>
      <Layout.Body size="md">
        <Skeleton height="auto" isLoaded={!loading} width="full">
          <HStack alignItems="center" marginBottom="space-40">
            <AccountSetupCircularProgress
              progress={progressValue}
              progressLabel={progressLabel}
            />

            <Heading size="lg">{locales.title}</Heading>
          </HStack>

          <HStack spacing="space-24">
            {actionItems.map((actionItem) => (
              <>
                {!actionItem.isSkipped ? (
                  <AccountSetupActionCard
                    actionItem={actionItem}
                    key={actionItem.text}
                    onDismiss={() => onDismiss(actionItem)}
                  />
                ) : null}
              </>
            ))}
          </HStack>
        </Skeleton>
        <OnboardingStepRemovalModal
          isOpen={isModalOpen}
          onClose={onModalClose}
          selectedActionItem={selectedActionItem}
        />
      </Layout.Body>
    </Layout.Root>
  );
};

export default Setup;
